module.exports = __webpack_public_path__ + "img/planet.c6cf7a18.png";